import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setIsAuthenticated, fetchInstance } from 'modules/app';
import { getStepsWatchedAction, resetLoadingAction } from 'store/globalState/global';
import { hideModalInformation } from 'components/ModalInformation/modules/actions';
import AppComponents from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals,
  sessionChecked: state.session.checked,
  loading: state.global.loading,
  router: state.router,
  app: state.app,
  actualContext: state.steps.context,
  isAuthenticated: state.app.isAuthenticated,
  user: state.session,
  chats: state.chats,
  lastLoading: state.global.lastLoading,
});

function mapDispatchToProps(dispatch) {
  return {
    fetchInstance: bindActionCreators(fetchInstance, dispatch),
    setIsAuthenticated: bindActionCreators(setIsAuthenticated, dispatch),
    getStepsWatched: bindActionCreators(getStepsWatchedAction, dispatch),
    hideModal: bindActionCreators(hideModalInformation, dispatch),
    resetLoading: bindActionCreators(resetLoadingAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppComponents);



// WEBPACK FOOTER //
// ./src/routes/App/container/index.js